/**
 * Six sets fill a 3440px window plus one more set, so the loop never shows a
 * seam. The keyframe in homepage-hero.css moves by exactly `-100% / 6`: change
 * the two together.
 */
const SETS = 6

/**
 * Inter has no ★, so the character would fall back to whichever system font
 * has one and render differently on every device. The star is drawn instead,
 * and announced as "4.9 stars".
 */
const ClaimSet = ({ isClone }) => (
    <ul
        className="falh-strip-set"
        aria-hidden={isClone ? "true" : undefined}
    >
        <li className="falh-strip-item">BBB-accredited</li>
        <li className="falh-strip-item">
            A+ rated, 27,000+ reviews on GunBroker
        </li>
        <li className="falh-strip-item">
            <span>
                4.9
                <svg
                    className="falh-star"
                    viewBox="0 0 24 23"
                    fill="currentColor"
                    aria-hidden="true"
                    focusable="false"
                >
                    <path d="M12 0l3.53 7.6 8.47.93-6.29 5.78 1.71 8.35L12 18.5l-7.42 4.16 1.71-8.35L0 8.53l8.47-.93z" />
                </svg>
                <span className="sr-only"> stars</span>, 2,900+ reviews on
                Google
            </span>
        </li>
        <li className="falh-strip-item">$40M+ paid to sellers</li>
    </ul>
)

/**
 * The one pause control stops both moving things in the hero, this strip and
 * the rotating word (WCAG 2.2.2), so its state lives in HomepageHero.
 */
export const HeroTrustStrip = ({ isPaused, onTogglePause }) => (
    <div className="falh-strip">
        <div className="falh-strip-track">
            {Array.from({ length: SETS }, (_, set) => (
                <ClaimSet key={set} isClone={set > 0} />
            ))}
        </div>

        <div className="falh-strip-controls">
            <div className="container mx-auto h-full px-5 xl:px-10">
                <div className="relative h-full">
                    <button
                        type="button"
                        className="falh-pause"
                        onClick={onTogglePause}
                        aria-label={
                            isPaused ? "Play animations" : "Pause animations"
                        }
                    >
                        {isPaused ? (
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                aria-hidden="true"
                            >
                                <path d="M3 1.5v9l7.5-4.5z" fill="currentColor" />
                            </svg>
                        ) : (
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                aria-hidden="true"
                            >
                                <rect
                                    x="2.5"
                                    y="1.5"
                                    width="2.5"
                                    height="9"
                                    fill="currentColor"
                                />
                                <rect
                                    x="7"
                                    y="1.5"
                                    width="2.5"
                                    height="9"
                                    fill="currentColor"
                                />
                            </svg>
                        )}
                    </button>
                </div>
            </div>
        </div>
    </div>
)
